window.PlummeI18n.register('en', {
  'vat.special.title': 'VAT on remotely supplied services',
  'vat.special.help': 'A Norwegian business that is not VAT registered may need a separate quarterly return for remotely supplied services bought abroad. Plumme calculates the basis from posted purchases using code 87.',
  'vat.special.quarter': 'Quarter {quarter}, {year}',
  'vat.special.ready': 'The quarter has ended and can be reviewed.',
  'vat.special.notEnded': 'The quarter has not ended.',
  'vat.special.review': 'Review calculation',
  'vat.special.recorded': 'Recorded locally',
  'vat.special.recordedAmounts': 'Basis {basis} · VAT {vat}',
  'vat.special.confirmTitle': 'Review separate VAT return',
  'vat.special.confirmText': 'For quarter {quarter}, the basis is {basis} and calculated VAT is {vat}.',
  'vat.special.postingWarning': 'Confirmation posts output VAT to 2700 and increases the cost. No input VAT deduction is created.',
  'vat.special.belowThreshold': 'The basis does not exceed the threshold. Confirmation records the review without a VAT posting.',
  'vat.special.externalWarning': 'This does not file the return with the tax authority. Filing and payment must be completed outside Plumme.',
  'vat.special.record': 'Record review and posting',
  'vat.special.recordedToast': 'The review was recorded',
  'vat.special.previewFailed': 'Could not calculate the separate VAT return.',
  'vat.special.recordFailed': 'Could not record the separate VAT return.',
  'vat.special.reverse': 'Reverse local record',
  'vat.special.reverseTitle': 'Reverse separate VAT return',
  'vat.special.reverseText': 'This reverses the local posting for quarter {quarter}, basis {basis} and VAT {vat}. It does not correct a return filed with the tax authority.',
  'vat.special.reverseReason': 'Reason for reversal',
  'vat.special.reverseReasonRequired': 'Enter a reason before reversing the local return.',
  'vat.special.reversedToast': 'The local return was reversed',
  'vat.special.reverseFailed': 'Could not reverse the local return.',
  'err.nativeValidation.reverseChargeReturn.7': 'The reverse-charge basis changed after preview. Review the updated amounts before recording.',
  'err.nativeValidation.reverseChargeReturn.8': 'Review the reverse-charge calculation before recording it.',
  'err.nativeValidation.reverseChargeReturn.9': 'Document why the separate reverse-charge return is being reversed.',
  'err.nativeValidation.reverseChargeReturn.10': 'The reverse-charge posting is no longer active.',
});
